// This component bypasses the default behavior, that increases/decreases the value when scrolling with the input selected

import { CSSProperties } from "react";

interface NumberInputProps {
    id?: string;
    required?: boolean;
    value?: number | string;
    className: string;
    onChange: (e: any) => void;
    onKeyDown?: (e: any) => void;
    onKeyUp?: (e: any) => void;
    placeholder?: string;
    maxLength?: number;
    style?: CSSProperties;
    ref?: React.RefObject<HTMLInputElement>;
    onBlur?: () => void;
}

function NumberInput({
    id,
    required,
    value,
    className,
    onChange,
    placeholder,
    maxLength,
    style,
    ref,
    onBlur,
    onKeyDown,
    onKeyUp,
}: NumberInputProps) {
    const numberInputOnWheelPreventChange = (e: any) => {
        // Prevent the input value change
        e.target.blur();

        // Prevent the page/container scrolling
        e.stopPropagation();

        // Refocus immediately, on the next tick (after the current function is done
        setTimeout(() => {
            e.target.focus();
        }, 0);
    };

    return (
        <input
            id={id}
            required={required}
            type="number"
            value={value}
            className={className}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            onWheel={numberInputOnWheelPreventChange}
            style={style}
            ref={ref}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
        />
    );
}

export default NumberInput;
